import { environment as prodEnvironment } from './environment.prod';

// ads cluster, production (ads.adquilt.ad). Same as production except the backend hosts.
// NOTE: config_url (S3 remoteadshostconfig.json), firebase, fingerprint (cheelee.io proxy) and sentry are inherited from production.
export const environment = {
  ...prodEnvironment,
  base_url: 'https://ads-api.adquilt.ad',
  auth_url: 'https://ads-api-authgate.adquilt.ad',
};
